/** Bitácora en memoria para el feedback (docs/modulos/feedback-app-spec.md §3). Solo forma,
 * nunca datos: el backend rechaza cualquier otro campo (`PasoBitacora`, `extra="forbid"`). */

export type PasoBitacora = {
  tipo: 'ruta' | 'evento' | 'error'
  /** Milisegundos desde el primer paso: un reloj relativo, nunca una hora. */
  t: number
  ruta?: string
  evento?: string
  metodo?: string
  status?: number
  clave?: string
}

const MAX_PASOS = 50
/** Igual que `feedback_resumen.py::MIN_PASOS` del backend. */
export const MIN_PASOS_RESUMEN = 3
const MAX_T = 86_400_000
const MAX_RUTA = 300

let pasos: PasoBitacora[] = []
let inicio: number | null = null

function t(): number {
  if (inicio === null) inicio = Date.now()
  return Math.min(Math.max(0, Date.now() - inicio), MAX_T)
}

function anotar(paso: PasoBitacora): void {
  pasos.push(paso)
  if (pasos.length > MAX_PASOS) pasos = pasos.slice(-MAX_PASOS)
}

/** Un uuid o un número se vuelve `:id`: ni la bitácora ni Sentry llevan identificadores. */
export function patronDeRuta(ruta: string): string {
  return ruta
    .split('/')
    .map((segmento) => (/^[0-9a-f-]{8,}$/i.test(segmento) || /^\d+$/.test(segmento) ? ':id' : segmento))
    .join('/')
    .slice(0, MAX_RUTA)
}

export function anotarRuta(pathname: string): void {
  const ruta = patronDeRuta(pathname)
  const ultima = pasos.findLast((p) => p.tipo === 'ruta')
  if (ultima?.ruta === ruta) return
  anotar({tipo: 'ruta', t: t(), ruta})
}

export function anotarEvento(evento: string): void {
  anotar({tipo: 'evento', t: t(), evento: evento.slice(0, 80)})
}

/** Entrar o salir de «Ver como»: solo el hecho, nunca quién. */
export function anotarLente(entra: boolean): void {
  anotarEvento(entra ? 'ver como' : 'salir de la lente')
}

export function anotarError(error: {metodo: string; ruta: string; status?: number; clave: string}): void {
  anotar({
    tipo: 'error',
    t: t(),
    metodo: error.metodo.slice(0, 10),
    ruta: patronDeRuta(error.ruta),
    ...(error.status !== undefined ? {status: error.status} : {}),
    clave: error.clave.slice(0, 200),
  })
}

export function leerBitacora(): PasoBitacora[] {
  return pasos.map((p) => ({...p}))
}

export function vaciarBitacora(): void {
  pasos = []
  inicio = null
}
